import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';

import { Divider } from 'apps/components/shared';
import { LargePanelSectionWrapper } from 'apps/rfq/rfqForm/views/onboarding.styled';

import RFQIntro from 'apps/rfq/rfqPage/views/rfqIntro';
import NeedPerfectQuote from 'apps/rfq/rfqPage/views/needPerfectQuote';
import DetailsBlock from 'apps/rfq/rfqPage/views/detailsBlock';

import { RFQIssues } from './RFQIssues';
import { ShipmentQuotes } from '../../ShipmentQuotes';

const CustomerRFQPage = observer(props => {
  const { rfqManager } = props;
  const { rfqApp } = rfqManager;

  return (
    <>
      <RFQIntro rfqManager={rfqManager} rfqApp={rfqApp} isCustomer />
      <RFQIssues rfqManager={rfqManager} />
      <NeedPerfectQuote rfqManager={rfqManager} isCustomer />
      <ShipmentQuotes
        rfqId={rfqApp.id}
        shipmentQuotes={rfqApp.shipmentQuotes.apps}
      />
      <DetailsBlock rfqManager={rfqManager} jobSpec={rfqApp.jobSpec} />
      <LargePanelSectionWrapper>
        <Divider spacing='default' />
      </LargePanelSectionWrapper>
    </>
  );
});

CustomerRFQPage.propTypes = {
  rfqManager: PropTypes.object,
};

export default withNamespaces()(CustomerRFQPage);
